/**
 * @module header/components/help_drawer_button
 */
import React, { PropTypes } from 'react';
import HelpDrawer from 'common/components/base_ui/help_drawer';

/**
 * Button to toggle help drawer
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
const HelpDrawerButton = ({ helpDrawerVisible, shouldShow, toggleHelpDrawer, isLoggedIn }) => {
  if (!shouldShow) {
    return null;
  }
  
  console.log("---->logged in:" + isLoggedIn)
  
  const classes = isLoggedIn ? "columns small-4 small-offset-4 medium-14 medium-offset-0 large-15" : "columns small-4 small-offset-4 medium-12 medium-offset-0 large-13"

  return (
          <div className={classes}>
            <button type="button" className="btn btn-text btn-md show-for-small-only btn-help" onClick={toggleHelpDrawer}>
              { helpDrawerVisible ? 'Close' : 'Help' }
            </button>
            <HelpDrawer desktop={true} />
          </div>
  );
};

HelpDrawerButton.propTypes = {
  shouldShow: PropTypes.bool,
  helpDrawerVisible: PropTypes.bool,
  toggleHelpDrawer: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool,
};

export default HelpDrawerButton;



// WEBPACK FOOTER //
// ./header/components/help_drawer_button.jsx